// Iter 387 — Vista general: auxiliares (clientes/proveedores) con anticipos pendientes de regularizar.
import { fmtFecha } from '../../../lib/utils';
import { Badge } from '../../../components/ui/badge';
import { Button } from '../../../components/ui/button';
import { ArrowRight, Sparkles, AlertTriangle } from 'lucide-react';
import { fmtCLP, fmtRut, LADO_INFO } from './regularizacionUtils';

export function AuxiliaresTable({ lado, auxiliares, loading, onAbrir }) {
  const info = LADO_INFO[lado];
  if (loading) return <div className="p-8 text-center text-sm text-muted-foreground" data-testid="aux-loading">Cargando…</div>;
  if (!auxiliares.length) {
    return <div className="p-8 text-center text-sm text-muted-foreground" data-testid="aux-vacio">No hay {info.auxiliarPlural} con anticipos pendientes de regularizar con estos filtros.</div>;
  }
  return (
    <div className="overflow-x-auto" data-testid="tabla-auxiliares">
      <table className="w-full text-sm">
        <thead className="bg-muted/60 text-xs uppercase text-muted-foreground">
          <tr>
            <th className="text-left px-3 py-2">{info.auxiliar}</th>
            <th className="text-right px-3 py-2">Anticipos pendientes</th>
            <th className="text-right px-3 py-2">Saldo anticipos</th>
            <th className="text-right px-3 py-2">Docs. pendientes</th>
            <th className="text-right px-3 py-2">Saldo documentos</th>
            <th className="text-left px-3 py-2">Mov. más antiguo</th>
            <th className="text-center px-3 py-2">Sugerencias</th>
            <th className="px-3 py-2" />
          </tr>
        </thead>
        <tbody>
          {auxiliares.map((a) => (
            <tr key={a.rut} className="border-t hover:bg-indigo-50/40 cursor-pointer" onClick={() => onAbrir(a)} data-testid={`aux-row-${a.rut}`}>
              <td className="px-3 py-2">
                <div className="font-medium truncate max-w-[320px]" title={a.nombre}>{a.nombre}</div>
                <div className="text-[11px] text-muted-foreground font-mono">{fmtRut(a.rut)}</div>
              </td>
              <td className="px-3 py-2 text-right tabular-nums">
                {a.n_anticipos}
                {a.sin_verificar > 0 && <span className="ml-1 text-[10px] text-amber-700" title="Cuenta contable sin verificar en Alegra"><AlertTriangle className="w-3 h-3 inline" /></span>}
              </td>
              <td className="px-3 py-2 text-right tabular-nums font-semibold text-emerald-700">{fmtCLP(a.saldo_anticipos)}</td>
              <td className="px-3 py-2 text-right tabular-nums">{a.n_documentos}</td>
              <td className="px-3 py-2 text-right tabular-nums font-semibold text-rose-700">{a.saldo_documentos ? fmtCLP(a.saldo_documentos) : <span className="text-muted-foreground font-normal">—</span>}</td>
              <td className="px-3 py-2 text-xs whitespace-nowrap">{fmtFecha(a.fecha_mas_antigua)}</td>
              <td className="px-3 py-2 text-center">
                {a.sugerencias > 0
                  ? <Badge className="bg-indigo-600 hover:bg-indigo-600 text-[10px]" data-testid={`aux-sug-${a.rut}`}><Sparkles className="w-3 h-3 mr-1" />{a.sugerencias} · {fmtCLP(a.monto_sugerido)}</Badge>
                  : <span className="text-xs text-muted-foreground">{a.n_documentos ? 'manual' : 'sin documentos'}</span>}
              </td>
              <td className="px-3 py-2 text-right">
                <Button size="sm" variant="ghost" className="h-7 text-xs" data-testid={`aux-abrir-${a.rut}`}>Trabajar <ArrowRight className="w-3.5 h-3.5 ml-1" /></Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
